import React from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Text } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { changeValueOfArrayImmutable } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import PaperWrapper from "../../components/utilities/PaperWrapper";

import ComponentBarangActual from "./ComponentBarangActual";

const SedangJemputInputData = ({
    stateData,
    fnRefreshIndex,
    fnCloseDrawer,
    fnSuccessSubmit,
    fnClickPhoto
}) => {

    const mountedRef = React.useRef(true);
    const { URI1 } = useParams();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetData: 'sedangJemputInputData-1',
    })

    const [data, setData] = React.useState({
        data: [],
        dataFlag: 'idle',
        dataInitLoading: false,

        customerId: '',

        barang: {
            dataBarangCategory: [],
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    React.useEffect(() => {
        if (URI1) {

            setData(d => ({ ...d, dataInitLoading: true }))

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('flag_all', utils.flagAll);
            formDT.append('trx_id', URI1);
            formDT.append('current_step', stateData.utilsRef.currentStep);
            formDT.append('is_cancel', stateData.utilsRef.isCancel);

            axios({
                method: 'post',
                url: BE_API_THREE + '/data_init_delivery_penjemputan__by_penjemputan_id_sedang_jemput',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, dataInitLoading: false }));

                if (response.data.flag_status === 'isset') {
                    setData(d => ({
                        ...d,
                        data: response.data.data,
                        dataFlag: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? true : false,

                        barang: {
                            ...d.barang,
                            dataBarangCategory: response.data.data_barang_category
                        },

                        customerId: (Array.isArray(response.data.data) && (response.data.data.length > 0)) ? response.data.data[0]['customer_id'] : '',
                    }))
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorGetData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    dataInitLoading: false
                }))

                notifications.show({
                    id: notificationId.current.errorGetData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }, [handleSetLoginContext, loginContext, loginContext.syswebapp, URI1, stateData.utilsRef.currentStep, stateData.utilsRef.isCancel])

    return (
        <React.Fragment>
            {data.dataInitLoading &&
                <PaperWrapper stateMT="1rem">
                    <Text size='sm' color="dimmed">Loading Data..</Text>
                </PaperWrapper>
            }

            {!data.dataInitLoading && Array.isArray(data.data) && (data.data.length <= 0) &&
                <PaperWrapper stateMT="1rem">
                    <Text size='sm' color="dimmed">No Data</Text>
                </PaperWrapper>
            }

            {!data.dataInitLoading && Array.isArray(data.data) && (data.data.length > 0) && Object.keys(data.data).map((keyD, indexD) => {
                return (
                    <React.Fragment key={keyD}>
                        <ComponentBarangActual
                            dataDataKey={data.data[keyD]}
                            dataCategoryBarang={data.barang.dataBarangCategory}
                            stateKey={keyD}
                            stateCustomerId={data.customerId}
                            utilsRef={{
                                currentStep: stateData.utilsRef.currentStep,
                                isCancel: stateData.utilsRef.isCancel
                            }}

                            fnCloseDrawer={fnCloseDrawer}

                            fnBarangPackage={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }))
                            }}

                            fnBarang={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }))
                            }}

                            fnBarangDelete={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }))
                            }}

                            fnChangeFoto={(stateKey, stateProp, newVal) => {
                                setData(d => ({
                                    ...d,
                                    data: changeValueOfArrayImmutable(data.data, stateKey, stateProp, newVal),
                                }))
                            }}

                            fnClickPhoto={fnClickPhoto}
                        />
                    </React.Fragment>
                )
            })}

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default SedangJemputInputData;